import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { Accordion, MultiRadio } from 'shared/components';

import './IrregularityType.scss';

const transform = (listOfOptions) =>
  listOfOptions
    .filter((optionType) => !optionType.systemGenerated)
    .map((option) => {
      const newObj = {
        label: option.name,
        key: ' ' + option.id,
        value: option.irregularityCategory.id + '&' + option.id,
      };
      return newObj;
    });

const checkIfSelected = (type) =>
  type.irregularityCategory.id && type.id ? type.irregularityCategory.id + '&' + type.id : '';

const findStartPosition = (categories, selected) =>
  categories.findIndex((category) => category.id === +selected.split('&')[0]);

class IrregularityType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      irregularity: props.irregularity,
      irregularityCategories: props.irregularityCategories || [],
      selectedType: props.irregularity && checkIfSelected(props.irregularity.irregularityType),
      isDirty: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onContinue = this.onContinue.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      !isEmpty(this.props.irregularityCategories) &&
      prevProps.irregularityCategories !== this.props.irregularityCategories
    ) {
      this.setState({
        irregularityCategories: this.props.irregularityCategories,
      });
    }
  }

  onChange(e) {
    this.setState({
      selectedType: e.target.value,
      isDirty: true,
    });
  }

  onContinue() {
    const { irregularity } = this.state;
    const categoryId = +this.state.selectedType.split('&')[0];
    const typeId = +this.state.selectedType.split('&')[1];
    const irregularityCategory = this.state.irregularityCategories.find(
      (category) => category.id === categoryId
    );

    irregularity.irregularityType = irregularityCategory.irregularityTypes.find(
      (type) => type.id === typeId
    );

    this.props.onContinue(irregularity, this.state.isDirty);
    this.setState({
      isDirty: false,
    });
  }

  render() {
    const { irregularityCategories } = this.props;

    return irregularityCategories.length ? (
      <section className="irregularities-types">
        <h4>{this.props.t('irregularities.typeTitle')}</h4>
        <p>{this.props.t('irregularities.typeSubtitle')}</p>
        <div className="test-dates">
          <Accordion
            startPosition={findStartPosition(irregularityCategories, this.state.selectedType)}>
            {irregularityCategories.map((category) => (
              <div
                className="category-container"
                key={category.id}
                data-trigger={
                  <HeadLabel
                    category={category}
                    disableButton={+this.state.selectedType.split('&')[0] !== category.id}
                    selectedType={this.state.selectedType}
                    onContinue={this.onContinue}
                  />
                }>
                <MultiRadio
                  radioList={transform(category.irregularityTypes)}
                  checkedValue={this.state.selectedType}
                  onChange={this.onChange}
                />
                <button
                  className="btn btn-action w-100 m-0 mt-3"
                  disabled={+this.state.selectedType.split('&')[0] !== category.id}
                  onClick={this.onContinue}>
                  {this.props.t('irregularities.selectOption')}
                </button>
              </div>
            ))}
          </Accordion>
          <button className="btn btn-warn w-100 mt-4 m-0" onClick={this.props.onBack}>
            {this.props.t('common.labels.back')}
          </button>
        </div>
      </section>
    ) : null;
  }
}

const HeadLabel = (props) => {
  return (
    <div className="collapse-header">
      <div className="header-category w-75">
        <p>{props.category.name}</p>
        {!!props.category.description && <p>{props.category.description}</p>}
      </div>
      <button className="btn-link" disabled={props.disableButton} onClick={props.onContinue}>
        {!props.disableButton ? (
          <i className="fa fa-chevron-right" aria-hidden="true" />
        ) : (
          <i className="fa fa-chevron-down" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

IrregularityType.propTypes = {
  onContinue: PropTypes.func.isRequired,
  irregularityCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  irregularity: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(IrregularityType);
